import { SunOutlined, MoonOutlined } from '@ant-design/icons';
import { Switch } from 'antd';
import { useContext } from 'react';
import { ThemeContext } from '../contexts/theme';
export function ThemeSwitcher() {
    const [ Theme, setTheme] = useContext(ThemeContext)
    return (    
        <Switch
            checkedChildren={<SunOutlined />}
            unCheckedChildren={<MoonOutlined />}
            defaultChecked={Theme === "light" ? true : false}
            onChange={setTheme}
        />
    )
}